import * as React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Table } from "components/bootstrap";
import { Spinner } from "components/common";
import { FiltersRow } from "security-app/components/common";
import { useGetUsersNTeams } from "security-app/hooks/useSecurityEventsAPI";
import ListHeader from "./ListHeader";
import ListRows from "./ListRows";
function List({ ownerId, setOwnerId }) {
  const { t } = useTranslation("enterprise_security_events");
  const { usersNTeams, loadingUsersNTeams } = useGetUsersNTeams();
  const [options, setOptions] = useState(usersNTeams);
  const [filters, setFilters] = useState({});
  useEffect(() => setOptions(usersNTeams), [usersNTeams]);
  const removeFilter = (filterKey) => (e) => {
    e.preventDefault();
    const auxFilters = { ...filters };
    delete auxFilters[filterKey];
    if (Object.keys(auxFilters).length) {
      setOptions(
        usersNTeams.filter(
          (option) => Object.values(auxFilters).flat().map(({ value }) => value).includes(option[filterKey])
        )
      );
    } else {
      setOptions(usersNTeams);
    }
    setFilters(auxFilters);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FiltersRow, { filters, onRemove: removeFilter }), /* @__PURE__ */ React.createElement(Table, { condensed: true, "data-testid": "open-investigations-list" }, /* @__PURE__ */ React.createElement(
    ListHeader,
    {
      ownerOptions: usersNTeams,
      filters,
      setFilters,
      setCurrentOptions: setOptions
    }
  ), /* @__PURE__ */ React.createElement("tbody", null, loadingUsersNTeams ? /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2, "aria-label": t("users_list.spinner_label") }, /* @__PURE__ */ React.createElement(Spinner, { text: t("users_list.loading") }))) : /* @__PURE__ */ React.createElement(ListRows, { ownerOptions: options, filters, setOwnerId, ownerId }))));
}
export default List;
